document.addEventListener('DOMContentLoaded', function() {
    // hack for shopify and theme's scripts that are forcing navigation on click
    const oldLoadMoreBtn = document.querySelector('#CollectionAjaxContent .load-more__btn');
    if (!oldLoadMoreBtn) return;
    const loadMoreBtn = oldLoadMoreBtn.cloneNode(true);
    oldLoadMoreBtn.parentNode.replaceChild(loadMoreBtn, oldLoadMoreBtn);

    // ensure that load-more button has only our listener
    loadMoreBtn.addEventListener('click', function(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        const url     = loadMoreBtn.getAttribute('href');
        const productGrid    = document.querySelector('.product-grid-container');
        const loadMoreSpinner = document.querySelector('#CollectionAjaxContent .loading__spinner');
        const loadMoreCounter = document.querySelector('#CollectionAjaxContent .load-more__counter .count');

        loadMoreBtn.classList.add('hidden');
        loadMoreSpinner.classList.remove('hidden');

        (async () => {
            try {
                const response  = await fetch(url);
                const responseText  = await response.text();
                const parser       = new DOMParser();
                const nextPageHtml  = parser.parseFromString(responseText, 'text/html');
                const nextGrid = nextPageHtml.querySelector('.product-grid-container');
                const nextItems = nextGrid ? nextGrid.querySelectorAll('.grid-product') : [];
                const newLoadBtn  = nextPageHtml.querySelector('.load-more__btn');
                const newNextUrl = newLoadBtn ? newLoadBtn.getAttribute('href') : null;

                // append the products the grid
                nextItems.forEach(i => productGrid.appendChild(i));

                // update load-more, spinner and counter
                if (newNextUrl) {
                    loadMoreBtn.setAttribute('href', newNextUrl);
                    loadMoreBtn.classList.remove('hidden');
                }

                loadMoreCounter.textContent = Number(loadMoreCounter.textContent) + nextItems.length;
                loadMoreSpinner.classList.add('hidden');

                // dispatch the custom event 'grid-update'
                document.dispatchEvent(new CustomEvent('grid-update'));

            } catch (err) {
                console.error(err);
                loadMoreSpinner.classList.add('hidden');
                loadMoreBtn.classList.remove('hidden');
            }
        })();
    });
});
